import { Button, HStack } from '@chakra-ui/react';

export type FilterActionButtonsProps = {
  onClickCancel?: () => void;
  onClickApply?: () => void;
};

export const FilterActionButtons = ({ onClickApply, onClickCancel }: FilterActionButtonsProps) => {
  return (
    <HStack spacing="2" justify="space-between">
      <Button size="sm" variant="ghost" onClick={onClickCancel}>
        Cancel
      </Button>
      <Button size="sm" colorScheme="brand" variant="primary" onClick={onClickApply}>
        Apply
      </Button>
    </HStack>
  );
};
